/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Button, ButtonBase, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import logo_blanco from '../../Recursos/logo_blanco.svg'
import {SECCIONES} from "../../Constantes";
import {useState} from "react";
import {useNavigate} from "react-router";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";
import {ShoppingCartOutlined} from '@mui/icons-material'

const BarraPc = () => {
    const navigate = useNavigate()
    const [navegando, setNavegando] = useState(false)
    const {ir} = useIrRuta()
    const {Carrito, abrir, productos} = useCarritoLateral()


    return (
        <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            size={12}
            sx={{
                transition: 'all .2s ease-in-out',
                backgroundColor: theme.palette.primary.main,
                borderBottom: 8,
                borderColor: theme.palette.secondary.main,
                boxShadow: navegando ? 4 : 0
            }}

        >
            <Carrito/>

            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                size={12}
                sx={{transition: 'all .2s ease-in-out', maxWidth: '1400px', px: 4, py: navegando ? 1 : 2}}
            >


                <Grid item container size={{xs: 12, sm: 5, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <img
                        onClick={() => navigate('/')}
                        src={logo_blanco} width={navegando ? 100 : 140} height={'auto'}
                        style={{cursor: 'pointer', transition: 'all .2s ease-in-out'}}/>
                </Grid>

                <Grid item container size={{xs: 12, sm: 5, md: 4}} sx={{justifyContent: 'flex-end'}}>
                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        size={12}
                    >


                        {SECCIONES.map((item, index) => {
                            return (
                                <ButtonBase
                                    onClick={() => ir(item)}
                                    key={`aa${index}`}
                                    sx={{
                                        transition: 'all .2s ease-in-out',
                                        borderBottom: 2, borderColor: '#ffffff00',
                                        '&:hover': {borderColor: '#ffffff'}
                                    }}>
                                    <Typography sx={{
                                        color: '#fff',
                                        fontSize: 18,
                                        fontWeight: 500,

                                    }}>{item}</Typography>
                                </ButtonBase>
                            )
                        })}


                    </Grid>
                </Grid>

                <Grid item container size={{xs: 12, sm: 2, md: 2}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => abrir()}
                        sx={{

                            px: 4,
                            py: 1
                        }}
                        startIcon={
                            <Badge badgeContent={productos.length}
                                   color="primary"
                                   anchorOrigin={{
                                       vertical: 'top',
                                       horizontal: 'left',
                                   }}
                            >
                                <ShoppingCartOutlined/>

                            </Badge>
                        }
                    >

                        Carrito


                    </Button>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default BarraPc    